import { useParams } from "react-router-dom";
import { bulletinProvider } from "../../services/bulletin.service";
import paths from "../../paths";
import {
  availableBettingSubTypes,
  availableFobBettingTypes,
  availableFobHippodromes,
  availableFobHippodromesSubject,
  fobBettingTypesIds,
  racesActionSubject,
} from "../../store/bulletin.store";
import React, { useEffect, useState } from "react";
import { CurrencyFormat, useForceUpdate } from "../../services/misc.functions";
import { Hippodrome } from "../../models/bulletin.models";
import { FobBetslip, MobileBetslip } from "../../shared/betslip/betslip";
import {
  betSlipActionSubject,
  mobileBetSlipActions,
  mobileBetSlipSubject,
  tjkBetSlipOptions,
  tjkBetslipStore,
  updateBetCount,
} from "../../services/betslip.service";
import { isMobile } from "../../App";
import { FobBettingTypeOptions } from "./components/fob-betting-options";
import { FobList } from "./components/fob.list";
import { FobCards } from "./components/fob.cards";
import blackHorse from "../../assets/img/siyahat.png";
import liveIcon from "../../assets/icons/live-bold.svg";
import goRightIcon from "../../assets/icons/go-right.svg";
import Draggable from "react-draggable";

let rediretor: any = null;

export function FobBettingIddaa() {
  const params: any = useParams();
  const forceUpdate = useForceUpdate();
  let hippodrome: any = null;
  const [smartView, setSmartView] = useState<any>(false);
  const [toggleBetslip, setToggleBetslip] = useState<any>(false);

  //fixme gereksizleri sondür ya da tek sefer çalışsın
  bulletinProvider.getAvailableFobHippodromes();
  var selectedHorses = tjkBetslipStore.filter((el: any) => fobBettingTypesIds.includes(el.bettingType));
  var betslipHippodrome;
  if (selectedHorses.length > 0) {
    betslipHippodrome = availableFobHippodromes.find((el: any) => el._id === selectedHorses[0].hippodrome);
  }

  if (params.hippodrome) {
    hippodrome = availableFobHippodromes.find((hippodrome: Hippodrome) => {
      return hippodrome.keyword.toLowerCase() + hippodrome._id === params.hippodrome.toLowerCase();
    });
    tjkBetSlipOptions.hippodrome = hippodrome;
  } else {
    hippodrome = "all";
    if (selectedHorses.length > 0) {
      if (betslipHippodrome) {
        tjkBetSlipOptions.hippodrome = betslipHippodrome;
      } else {
        tjkBetSlipOptions.hippodrome = availableFobHippodromes[0];
      }
    } else {
      tjkBetSlipOptions.hippodrome = availableFobHippodromes[0];
    }
  }

  useEffect(() => {
    let racesActionSubject_subscription = racesActionSubject.subscribe((res: any) => {
      if (res && res.action === "update" && hippodrome !== "all") {
        console.log(fobBettingTypesIds.includes(tjkBetSlipOptions.bettingType.id));
        if (!fobBettingTypesIds.includes(tjkBetSlipOptions.bettingType.id)) {
          bulletinProvider.getAvailableFobBettingTypes(hippodrome);
          if (!availableFobBettingTypes.find((b: any) => b.id === tjkBetSlipOptions.bettingType.id)) {
            if (availableFobBettingTypes.length > 0) {
              bulletinProvider.selectFobBettingType(hippodrome, availableFobBettingTypes[0].id);
              bulletinProvider.selectBettingColumn(1);
            }
          }
          bulletinProvider.getAvailableBettingSubTypes(tjkBetSlipOptions.bettingType);
          if (!availableBettingSubTypes.find((b: any) => b.id === tjkBetSlipOptions.bettingSubType.id)) {
            if (availableBettingSubTypes.length > 0) {
              bulletinProvider.selectBettingSubType(availableBettingSubTypes[0]);
              bulletinProvider.selectBettingColumn(1);
            }
          }
        }

        forceUpdate();
      } else if (res && res.action === "update") {
        // let slipItem = tjkBetslipStore.filter((el: any) => fobBettingTypesIds.includes(Number(el.bettingType)));
        // for (const slipItemElement of slipItem) {
        //     var _hippodrome = availableFobHippodromes.find((el: any) => el._id === slipItemElement.hippodrome);
        //     if (!_hippodrome.runsMap[Number(slipItemElement.run)].event_odds[Number(slipItemElement.horse)]?.show) {
        //         addToTJKBetSlip(1, _hippodrome.runsMap[Number(slipItemElement.run)], _hippodrome.runsMap[Number(slipItemElement.run)].horseMap[slipItemElement.horse], "remove");
        //     }
        // }
      }
    });
    return () => {
      racesActionSubject_subscription.unsubscribe();
    };
  });

  useEffect(() => {
    let mobileBetSlipSubject_subscription = mobileBetSlipSubject.subscribe((res: any) => {
      if (res) {
        forceUpdate();
      }
    });
    return () => {
      mobileBetSlipSubject_subscription.unsubscribe();
    };
  });

  useEffect(() => {
    let availableFobHippodromesSubject_subscription = availableFobHippodromesSubject.subscribe((res: any) => {
      forceUpdate();
    });
    return () => {
      availableFobHippodromesSubject_subscription.unsubscribe();
    };
  });

  useEffect(() => {
    let betSlipActionSubject_subscription = betSlipActionSubject.subscribe((res: any) => {
      forceUpdate();
    });
    return () => {
      betSlipActionSubject_subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (tjkBetSlipOptions.betSlipMultiply === 1) {
      tjkBetSlipOptions.betSlipMultiply = 10;
    }
  }, []);

  const selectBettingColumn = (no: any) => {
    bulletinProvider.selectBettingColumn(no);
    updateBetCount.status = true;
    forceUpdate();
  };

  const selectBettingSubType = (id: any) => {
    tjkBetSlipOptions.betSlipMultiply = 1;
    tjkBetSlipOptions.complete = false;
    betSlipActionSubject.next({ action: "complete" });
    bulletinProvider.selectBettingSubType(availableBettingSubTypes.find((el: any) => Number(el.id) === Number(id)));
    let tabs: any = [];
    for (
      let i = Number(tjkBetSlipOptions.bettingSubType.id);
      i < Number(tjkBetSlipOptions.bettingSubType.id) + tjkBetSlipOptions.bettingType.column;
      i += 1
    ) {
      tabs.push(i);
    }
    selectBettingColumn(1);
  };

  const selectBettingType = (id: any) => {
    bulletinProvider.selectFobBettingType(hippodrome, id);
    selectBettingSubType(availableBettingSubTypes[0].id);
  };

  const getTotalOdd = () => {
    let slipItems = tjkBetslipStore.filter((el: any) => fobBettingTypesIds.includes(Number(el.bettingType)));
    var total = 1;
    for (const slipItemElement of slipItems) {
      let hippodrome = availableFobHippodromes.find((el: any) => el._id === slipItemElement.hippodrome);
      if (hippodrome) {
        var odd = Number(
          hippodrome.runsMap[Number(slipItemElement.run)].event_odds[Number(slipItemElement.horse)]?.win_odds
        );
        if (odd !== 1) {
          total *= Number(
            hippodrome.runsMap[Number(slipItemElement.run)].event_odds[Number(slipItemElement.horse)]?.win_odds
          );
        } else {
          return "KO";
        }
      }
    }
    return total === 1 ? "KO" : total.toFixed(2);
  };

  const getLiveRunsCount = () => {
    let liveRunsCount = 0;

    for (const availableFobHippodrome of availableFobHippodromes) {
      for (const run of availableFobHippodrome.runs) {
        if (run.fob_wager_status) {
          liveRunsCount++;
        }
      }
    }
    return liveRunsCount || 0;
  };

  if (rediretor) {
    clearTimeout(rediretor);
  }
  //
  // if (!hippodrome) {
  //     rediretor = setTimeout(() => {
  //         let firstHippodrome = availableFobHippodromes.find((el: any) => el.wager_details.length > 0);
  //         if (firstHippodrome) {
  //             window.location.href = `${paths.fobBetting.url}/${firstHippodrome.keyword.toLowerCase()}${firstHippodrome._id}`;
  //         }
  //     }, 3000);
  //     return <></>;
  // }

  if (tjkBetSlipOptions.hippodrome != null) {
    if (hippodrome === "all") {
      bulletinProvider.getAvailableFobBettingTypes(tjkBetSlipOptions.hippodrome);
    } else {
      bulletinProvider.getAvailableFobBettingTypes(hippodrome);
    }

    let isExistFob = availableFobBettingTypes.find((b: any) => fobBettingTypesIds.includes(b.id));
    if (!fobBettingTypesIds.includes(tjkBetSlipOptions.bettingType?.id)) {
      if (isExistFob) {
        if (hippodrome === "all") {
          bulletinProvider.selectFobBettingType(tjkBetSlipOptions.hippodrome, isExistFob.id);
        } else {
          bulletinProvider.selectFobBettingType(hippodrome, isExistFob.id);
        }
      } else {
        if (availableFobBettingTypes.length > 0) {
          var slipItems = tjkBetslipStore.filter((el: any) => fobBettingTypesIds.includes(Number(el.bettingType)));
          console.log(slipItems);
          if (slipItems.length > 0) {
            try {
              bulletinProvider.selectFobBettingType(hippodrome, slipItems[0].bettingType);
            } catch (e) {
              bulletinProvider.selectFobBettingType(hippodrome, availableFobBettingTypes[0].id);
            }
          } else {
            bulletinProvider.selectFobBettingType(hippodrome, availableFobBettingTypes[0].id);
          }
        }
      }
    }
    bulletinProvider.selectBettingColumn(1);
  }
  if (hippodrome !== "all" && hippodrome) {
    if (tjkBetSlipOptions.hippodrome?._id !== hippodrome._id) {
      tjkBetSlipOptions.betSlipMultiply = 1;
      tjkBetSlipOptions.usePointBalance = false;
      bulletinProvider.getAvailableFobBettingTypes(hippodrome);
      try {
        // @ts-ignore
        fbq("track", "ViewContent", {
          content_name: hippodrome.hippodrome,
          content_category: tjkBetSlipOptions.bettingType.name,
          content_ids: "",
          content_type: "product",
          value: tjkBetSlipOptions.bettingType.price,
          currency: "TRY",
          event_source_url: `${paths.fobBetting.url}/${(hippodrome.keyword + hippodrome._id).toLowerCase()}`,
        });
      } catch (e) {
        console.log(e);
      }
    }
  }

  if (availableFobHippodromes.length > 0) {
    return (
      <>
        <FobBettingTypeOptions
          params={params}
          hippodrome={hippodrome}
          selectBettingType={selectBettingType}
          selectBettingSubType={selectBettingSubType}
          smartView={smartView}
          setSmartView={setSmartView}
        />

        {isMobile && mobileBetSlipActions.isOpen !== true && (
          <div className="row p-0 mb-2">
            <div className="col-1">
              <div className="live-icon-container">
                <img src={liveIcon} className="live-icon" alt="canli" />
                <span className="fob-badge" style={{ top: -5, right: -15 }}>
                  {getLiveRunsCount()}
                </span>
              </div>
            </div>
            <div className="col-7 fs-7 ps-3 pt-2 text-white">
              <span
                className="text-warning fw-bold cursor-pointer"
                onClick={() => setSmartView((prevSmartView: any) => !prevSmartView)}
              >
                Canlı Bahis
              </span>{" "}
              yapılabilir {getLiveRunsCount()} koşu var.
              {"  "}
            </div>
            <div className="col-4">
              <div
                className="btn btn-sm btn-secondary fw-semibold fs-7 mb-1 mt-1"
                style={{ color: "#1e3d98" }}
                onClick={() => setSmartView((prevSmartView: any) => !prevSmartView)}
              >
                {smartView && <img src={goRightIcon} alt="git" width={16} className={`me-1 flip-icon`} />}
                {smartView ? "Tüm Koşular" : "Aktif Koşular"}
                {!smartView && <img src={goRightIcon} alt="git" width={16} className={`ms-1`} />}
              </div>
            </div>
          </div>
        )}

        {!isMobile && mobileBetSlipActions.isOpen !== true && (
          <div className="d-flex flex-row gap-2 mb-1">
            <div className="live-icon-container">
              <img src={liveIcon} className="live-icon" alt="canli" />
              <span className="fob-badge">{getLiveRunsCount()}</span>
            </div>

            {getLiveRunsCount() > 0 ? (
              <>
                <div className="text-white">
                  <span
                    className="text-warning fw-bold cursor-pointer"
                    onClick={() => setSmartView((prevSmartView: any) => !prevSmartView)}
                  >
                    Canlı Bahis
                  </span>{" "}
                  yapılabilir {getLiveRunsCount()} koşu var.
                  {"  "}
                  <button
                    className="btn btn-sm btn-secondary fw-semibold fs-7 mb-1 mt-1"
                    style={{ color: "#1e3d98" }}
                    onClick={() => setSmartView((prevSmartView: any) => !prevSmartView)}
                  >
                    {smartView && <img src={goRightIcon} alt="git" width={16} className={`me-1 flip-icon`} />}
                    {smartView ? "Tüm Koşular" : "Aktif Koşular"}
                    {!smartView && <img src={goRightIcon} alt="git" width={16} className={`ms-1`} />}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="text-white">
                  <span
                    className="text-warning fw-bold cursor-pointer"
                    onClick={() => setSmartView((prevSmartView: any) => !prevSmartView)}
                  >
                    Canlı Bahis
                  </span>{" "}
                  yapılabilir aktif koşu yoktur.
                  {"  "}
                  <button
                    className="btn btn-sm btn-secondary fw-semibold fs-7 mb-1 tooltip mt-1"
                    style={{ color: "#1e3d98" }}
                    onClick={() => {}}
                  >
                    {smartView && <img src={goRightIcon} alt="git" width={16} className={`me-1 flip-icon`} />}
                    {smartView ? "Tüm Koşular" : "Aktif Koşular"}
                    {!smartView && <img src={goRightIcon} alt="git" width={16} className={`ms-1`} />}
                    <div className="tooltip-text">Canlı Bahis yapılabilir aktif koşu yoktur.</div>
                  </button>
                </div>
              </>
            )}
          </div>
        )}

        <div className="row">
          {!params.subpage && (
            <>
              {isMobile && mobileBetSlipActions.isOpen === true ? (
                <></>
              ) : (
                <div className={`"col-12`}>
                  <div className={smartView ? "" : ""}>
                    {smartView && <FobList></FobList>}
                    {!smartView && <FobCards hippodrome={hippodrome}></FobCards>}
                  </div>

                  {availableFobHippodromes.length == 0 && (
                    <div className={"page-widget"}>
                      <div className="hint-text text-center p-3" style={{ minHeight: "50vh" }}>
                        <p className={"fs-6 mb-0"}>Bu hipodromda açık koşu bulunmamaktadır.</p>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {!isMobile && toggleBetslip && (
                <Draggable>
                  <div className={"fob-betslip"}>
                    <FobBetslip isFob={true} setToggleBetslip={setToggleBetslip} />
                  </div>
                </Draggable>
              )}

              {!isMobile && !toggleBetslip && (
                <div
                  onClick={() => {
                    setToggleBetslip(true);
                  }}
                  className={"fob-toggle py-1"}
                >
                  <div className="d-flex align-items-center justify-content-start ">
                    <span className={`fob-toggle-icon`}>
                      <span className="horse-amount">{selectedHorses.length}</span>
                      <img src={blackHorse} alt="" />
                      <span className="up-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          fill="currentColor"
                          className="bi bi-caret-up"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659" />
                        </svg>
                      </span>
                    </span>
                    <div className="d-block justify-content-start ms-0">
                      <span className="fw-light">Oran:</span>
                      <span className="nowrap">{selectedHorses.length > 0 ? getTotalOdd() : "-"}</span>
                    </div>
                  </div>
                </div>
              )}

              {isMobile &&
                tjkBetSlipOptions.bettingType != null &&
                tjkBetSlipOptions.bettingType.id !== 0 &&
                mobileBetSlipActions.isOpen === false && (
                  <MobileBetslip isFob={true} selectBettingColumn={selectBettingColumn}></MobileBetslip>
                )}

              {isMobile && mobileBetSlipActions.isOpen === false ? (
                <></>
              ) : (
                <>
                  {tjkBetSlipOptions.bettingType != null && tjkBetSlipOptions.bettingType?.id !== 0 && isMobile && (
                    <div className="col-betslip">
                      <FobBetslip isFob={true} />
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </>
    );
  } else {
    return (
      <div className={`"col-12`}>
        <div className={"page-widget"}>
          <div className="hint-text text-center p-3">
            <p className={"fs-6 mb-0"}>Sabit ihtimalli bahis türünde açık hipodrom bulunmamaktadır.</p>
          </div>
        </div>
      </div>
    );
  }
}
